export const BASE_URL = '/api/v1';

// -------- 在庫管理 API --------

export const USER_PATH = `${BASE_URL}/users`;
export const USER_ROLE_PATH = `${BASE_URL}/user/roles`;
export const AUTH_PATH = `${BASE_URL}/auth`;
export const PASSWORD_RESET_PATH = `${USER_PATH}/password-reset`;

export const DIC_CATALOG_PATH = `${BASE_URL}/dic`;

export const LINES_PATH = `${BASE_URL}/lines`;
export const TRAINS_PATH = `${BASE_URL}/trains`;
export const SEATS_PATH = `${BASE_URL}/seats/by-train`;
export const STATIONS_PATH = `${BASE_URL}/stations`;
export const STATION_LOGIN_PATH = `${STATIONS_PATH}/login`;
export const TRAIN_DIRECTIONS_PATH = `${BASE_URL}/directions`;

export const SEAT_CLASS_TYPES_PATH = `${BASE_URL}/seat-class-types`;
export const TRAIN_SEAT_CLASSES_PATH = `${BASE_URL}/train-seat-classes`;
export const SEAT_ADJUSTMENT_TYPES_PATH = `${BASE_URL}/seat-adjustment-types`;
export const SEAT_ADJUSTMENTS_PATH = `${BASE_URL}/seat-adjustments`;

export const STATION_STOP_PATTERNS_LINE_PATH = `${BASE_URL}/station-stop-patterns/line`;
export const STATION_STOP_PATTERNS_PATH = `${BASE_URL}/station-stop-patterns`;

export const TRAIN_SCHEDULE_PATH = `${BASE_URL}/train-schedule`;
export const TRAIN_SERVICES_PATH = `${BASE_URL}/train-services`;
export const TRAIN_SCHEDULE_SEAT_PATH = `${BASE_URL}/train-schedule-seat`;
export const SEAT_ADJUSTMENTS_INDIVIDUAL_PATH = `${BASE_URL}/seat-adjustments-individual`;

export const SPECIAL_TRAINS_PATH = `${BASE_URL}/special-trains`;

export const TRAIN_ASSIGNMENTS_PATH = `${BASE_URL}/train-assignments`;

export const SUSPENSIONS_PATH = `${BASE_URL}/suspensions`;

export const WORKFLOWS_PATH = `${BASE_URL}/workflows`;

export const CALENDAR_PATH = `${BASE_URL}/calendar`;

export const INVENTORY_TRAINS_PATH = `${BASE_URL}/inventory/trains`;
export const INVENTORY_SEATS_PATH = `${BASE_URL}/inventory/seats`;
export const INVENTORY_SEATS_WITH_SUSPENSION_INFO_PATH = `${BASE_URL}/inventory/seats-with-suspension-info`;
export const INVENTORY_RESERVED_TRAINS_PATH = `${BASE_URL}/inventory/reserved-trains`;

export const SPECIAL_SEAT_ADJUSTMENT_PATH = `${BASE_URL}/special-seat-adjustments`;

export const ORDERS_PATH = `${BASE_URL}/orders`;

export const TIMETABLE_PATH = `${BASE_URL}/timetable`;

export const SEAT_ORDER_HISTORY_PATH = `${BASE_URL}/seat-order-history`;

// -------- 団体予約 API --------

export const AGENTS_PATH = `${BASE_URL}/agents`;
export const AGENT_GROUPS_PATH = `${BASE_URL}/agent-groups`;
export const AGENT_STAFFS_PATH = `${BASE_URL}/agent-staffs`;

// -------- 個人団体一覧 API --------
export const INDIVIDUAL_PATH = `${BASE_URL}/individuals`;

// 船車券設定 API
export const PRICING_PLANS_PATH = `${BASE_URL}/ticket-rebate-settings`;

export const MASTER_DATA_PATH = `${BASE_URL}/master-data`;

// 支付方式 API
export const PAYMENT_METHODS_PATH = `${MASTER_DATA_PATH}/payment-methods`;

// 事業者ユーザー詳細、登録、変更、削除 API
export const OPERATOR_BASIC_INFO_PATH = `${BASE_URL}/master-data/operator-basic-info`;

export const ALLOTMENTS_PATH = `${BASE_URL}/allotments`;
export const BOOKINGS_PATH = `${BASE_URL}/bookings`;

export const RESTAURANT_BOOKINGS_PATH = `${BASE_URL}/restaurant-bookings`;
export const RESTAURANTS_PATH = `${BASE_URL}/restaurant`;
export const GCP_FILES_PATH = `${BASE_URL}/files/gcp`;

export const TOUR_BOOKINGS_PATH = `${BASE_URL}/tours`;
export const NOTIFICATIONS_PATH = `${BASE_URL}/notifications`;
export const DASHBOARD_PATH = `${BASE_URL}/dashboard`;

export const PAYMENTS_PATH = `${BOOKINGS_PATH}/payments`;
export const CREDIT_CARD_PAYMENTS_PATH = `${BASE_URL}/payments/credit-card`;

// 団体料金設定 API
export const GROUP_FARE_SETTINGS_PATH = `${BASE_URL}/group-fare-settings`;

// 団体スケジュール API
export const GROUP_SCHEDULES_PATH = `${MASTER_DATA_PATH}/group-schedules`;

// -------- KNR 個券予約 API（駅務管理） --------
export const KNR_PATH = `${BASE_URL}/knr`;
export const KNR_STATIONS_PATH = `${KNR_PATH}/stations`;
export const KNR_DEPARTURES_PATH = `${KNR_PATH}/departures`;
export const KNR_SEAT_MAP_PATH = `${KNR_PATH}/seat-map`;
export const KNR_UNRIDDEN_SEAT_RELEASES_PATH = `${KNR_PATH}/unridden-seat-releases`;
// 価格試算・注文作成・注文照会（注文詳細は KNR_ORDERS_PATH + `/{orderId}` で構築）
export const KNR_ORDER_QUOTES_PATH = `${KNR_PATH}/orders/quotes`;
export const KNR_ORDERS_PATH = `${KNR_PATH}/orders`;
// 支払照会（KNR_PAYMENTS_PATH + `/{paymentId}` で構築）
export const KNR_PAYMENTS_PATH = `${KNR_PATH}/payments`;

// -------- サイネージ設定 API（駅務管理） --------
// 駅のサイネージ設定取得/保存は STATIONS_PATH + `/{stationId}/signage-setting` で構築
export const SIGNAGE_MESSAGES_PATH = `${BASE_URL}/signage-messages`;
